module.exports = __webpack_public_path__ + "static/img/Ticket Plus_logo_RGB@3x.a6fdf4e4.png";